import localforage from 'localforage';

const STORAGE_KEYS = [
  'token',
  'refreshToken',
  'userImage',
  'userType',
  'userName',
];

const Session = {
  getToken() {
    return localforage.getItem('token');
  },

  getRefreshToken() {
    return localforage.getItem('refreshToken');
  },

  async saveTokens({ token, refreshToken }) {
    await Promise.all([
      localforage.setItem('token', token),
      localforage.setItem('refreshToken', refreshToken),
    ]);
  },

  async readAll() {
    const values = await Promise.all(
      STORAGE_KEYS.map(key => localforage.getItem(key))
    );

    return Object.fromEntries(STORAGE_KEYS.map((key, i) => [key, values[i]]));
  },

  async clear() {
    await Promise.all(STORAGE_KEYS.map(key => localforage.removeItem(key)));
  },
};

export { STORAGE_KEYS };
export default Session;
